import React, { useState } from "react"
import ReactMarkdown, { Components } from "react-markdown"
import remarkGfm from "remark-gfm"
import { TextTile as TextTileDoc } from "features/Dashboard/types/dashboardDocument"
import {
  useDashboardStore,
  findTile,
} from "features/Dashboard/runtime/dashboardStore"

/** Links leave the dashboard in a new tab, with no access back to it. */
const MARKDOWN_COMPONENTS: Components = {
  a: ({ node: _node, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
}

/** Markdown text. In Build mode a double-click edits it in place; blur saves. */
const TextTile: React.FC<{ tile: TextTileDoc }> = ({ tile }) => {
  const mode = useDashboardStore((s) => s.mode)
  const updateTile = useDashboardStore((s) => s.updateTile)
  const pageId = useDashboardStore(
    (s) => findTile(s, tile.id)?.page.id ?? ""
  )
  const [draft, setDraft] = useState<string | null>(null)

  if (draft !== null) {
    return (
      <textarea
        className="dq-text-editor"
        aria-label="Text"
        autoFocus
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={() => {
          if (draft !== tile.markdown) {
            updateTile(pageId, tile.id, (t) =>
              t.type === "text" ? { ...t, markdown: draft } : t
            )
          }
          setDraft(null)
        }}
      />
    )
  }
  return (
    <div
      className="dq-text"
      onDoubleClick={() => mode === "build" && setDraft(tile.markdown)}
    >
      {tile.markdown.trim() ? (
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={MARKDOWN_COMPONENTS}
        >
          {tile.markdown}
        </ReactMarkdown>
      ) : (
        <p className="dq-tile__empty">
          {mode === "build" ? "Double-click to write" : ""}
        </p>
      )}
    </div>
  )
}

export default TextTile
